import { ActionLink, Container, Mono } from "@/components/site/primitives";

export default function NotFound() {
  return (
    <section data-testid="not-found">
      <Container className="py-28">
        <Mono accent>Not found</Mono>
        <h1 className="mt-5 font-display text-4xl font-extrabold sm:text-5xl lg:text-6xl">This page is not part of the structure.</h1>
        <p className="mt-5 max-w-xl text-o-dim">Use the navigation above, or return to the beginning.</p>
        <ActionLink to="/" testid="not-found-home" className="mt-10">Return home</ActionLink>
      </Container>
    </section>
  );
}
